import { Stack, Text, Loader, Center } from "@mantine/core";
import { Case } from "../../../services/cases.service";
import { HistoricalReportCard } from "../HistoricalReportCard";

interface HistoricalReportsWidgetProps {
  cases: Case[];
  isLoading: boolean;
  onViewReport: (caseId: string, caseNumber: string) => void;
}

export function HistoricalReportsWidget({
  cases,
  isLoading,
  onViewReport,
}: HistoricalReportsWidgetProps) {
  if (isLoading) {
    return (
      <Center py="md">
        <Loader size="sm" />
      </Center>
    );
  }

  if (cases.length === 0) {
    return (
      <Text size="xs" c="dimmed" fs="italic" py="xs">
        No historical reports found for this patient.
      </Text>
    );
  }

  return (
    <Stack gap="xs">
      {cases.map((pc) => (
        <HistoricalReportCard
          key={pc.id}
          caseData={pc}
          onViewReport={onViewReport}
        />
      ))}
    </Stack>
  );
}
